import React, { useState } from 'react';
import styles from './styles.module.scss';
import { ConsentState } from '../../types';

const PRIVACY_URL = 'https://www.enpal.com/it/protezione-dei-dati';

interface SuccessSlideProps {
  consents: ConsentState;
  onConsentsChange: (consents: ConsentState) => void;
}

const SuccessSlide: React.FC<SuccessSlideProps> = ({ consents, onConsentsChange }) => {
  const [editingPartner, setEditingPartner] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  return (
    <section className={styles.preferences}>
      <p className={styles.thankYou}>Grazie, ti contatteremo a breve per finalizzare la nostra offerta</p>

      <label className={styles.consentRow}>
        <input
          type="checkbox"
          checked={privacyAccepted}
          onChange={(event) => setPrivacyAccepted(event.target.checked)}
        />
        <span>
          <b>Obbligatorio.</b> Ho letto l&apos;
          <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
            informativa privacy
          </a>{' '}
          e acconsento al trattamento dei dati per essere ricontattato.
        </span>
      </label>
      <label className={styles.consentRow}>
        <input
          type="checkbox"
          checked={consents.enpalMarketingConsent}
          onChange={() =>
            onConsentsChange({
              ...consents,
              enpalMarketingConsent: !consents.enpalMarketingConsent,
            })
          }
        />
        <span>Acconsento a ricevere offerte e comunicazioni commerciali da Enpal. Facoltativo</span>
      </label>

      <h4 className={styles.preferencesTitle}>Le tue preferenze</h4>
      <p className={styles.preferencesHint}>Facoltativi, revocabili in ogni momento</p>

      <div className={styles.preferenceActions}>
        <button
          type="button"
          className={styles.preferenceBulk}
          onClick={() =>
            onConsentsChange({
              ...consents,
              enpalMarketingConsent: false,
              thirdPartyProfiling: false,
            })
          }
        >
          Deseleziona tutti
        </button>
        <button
          type="button"
          className={styles.preferenceBulk}
          onClick={() =>
            onConsentsChange({
              ...consents,
              enpalMarketingConsent: true,
              thirdPartyProfiling: true,
            })
          }
        >
          Seleziona tutti
        </button>
      </div>

      <label className={styles.preferenceCard}>
        <span className={styles.preferenceCardTop}>
          <span className={styles.preferenceName}>Proposte su misura (profilazione)</span>
          <input
            type="checkbox"
            className={styles.preferenceCheckbox}
            checked={consents.thirdPartyProfiling}
            onChange={() =>
              onConsentsChange({
                ...consents,
                thirdPartyProfiling: !consents.thirdPartyProfiling,
              })
            }
          />
        </span>
        <span className={styles.preferenceText}>
          Acconsento che Enpal Italia usi consumi, dati dell&apos;immobile e interazioni per propormi offerte su misura.
        </span>
      </label>

      <div className={styles.partnerRow}>
        <span>
          Dati ai partner: <strong>{consents.thirdPartyMarketing ? 'Sì' : 'No'}</strong>
        </span>
        <button
          type="button"
          className={styles.modifyLink}
          onClick={() => setEditingPartner((open) => !open)}
        >
          Modifica
        </button>
      </div>

      {editingPartner && (
        <label className={styles.preferenceCard}>
          <span className={styles.preferenceCardTop}>
            <span className={styles.preferenceName}>Comunicazione dei dati ai partner</span>
            <input
              type="checkbox"
              className={styles.preferenceCheckbox}
              checked={consents.thirdPartyMarketing}
              onChange={() =>
                onConsentsChange({
                  ...consents,
                  thirdPartyMarketing: !consents.thirdPartyMarketing,
                })
              }
            />
          </span>
          <span className={styles.preferenceText}>
            Acconsento a comunicare i miei dati ai partner in{' '}
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
              elenco
            </a>
            , per ricevere le loro offerte. Agiscono come titolari autonomi.
          </span>
        </label>
      )}
    </section>
  );
};

export default SuccessSlide;
